'use client';

import { Box, PopperProps } from '@mui/material';
import React, { FC } from 'react';

import { LocationSuggestionOption } from '../../location-search.types';
import { LocationDetailsLabels } from '../location-details/location-details.types';
import { LocationDetails } from '../location-details/LocationDetails';

import { LocationPopper } from './LocationSearchPopper.styling';

export const LocationSearchPopper: FC<
  PopperProps &
    LocationDetailsLabels & {
      showLocationDetailsFeature?: boolean;
      locationDetailOption?: LocationSuggestionOption | null;
      locationType?: 'pickup' | 'dropoff';
    }
> = ({
  showLocationDetailsFeature = false,
  locationDetailOption,
  uiTextData,
  locationType,
  ...props
}) => {
  const isShowLocationDetail =
    showLocationDetailsFeature && !!locationDetailOption;

  return (
    <LocationPopper {...props} disableRightBorderRadius={isShowLocationDetail}>
      <>
        {props.children}

        {isShowLocationDetail && (
          <Box
            sx={{
              overflow: 'hidden',
              position: 'absolute',
              top: 2,
              left: `${props?.style?.width ?? 0}px`,
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            <LocationDetails
              option={locationDetailOption}
              uiTextData={uiTextData}
              locationType={locationType}
            />
          </Box>
        )}
      </>
    </LocationPopper>
  );
};
